import { Message } from 'element-ui';
import dayjs from 'dayjs'


import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)


export const day8 = (val) => {
    return dayjs(val).utc().utcOffset(8)
}

export const aggre = (arr, prop) => {
    let res = []
    arr.forEach(item => {
        if (res.indexOf(item[prop]) < 0) {
            res.push(item[prop])
        }
    })
    return res
}

let loading = null

const showLoading = () => {
    if (!loading) {
        loading = Message.info({
            message:'请稍等...',
            iconClass:''
        })
    }
}